module.exports = __webpack_public_path__ + "img/gps.b40a8371.svg";